module.exports = __webpack_public_path__ + "static/media/logo_app_agent.1d712457.png";